import React from 'react';
import {
    Title,
    Message
} from '../../styles/ConfirmationModal.styles';

const ModalHeader = ({ title, message }) => (
    <>
        <Title>{title}</Title>
        <Message>{message}</Message>
    </>
);

export default ModalHeader;